"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Checkbox_1 = require("./Checkbox");
exports.default = Checkbox_1.default;
//# sourceMappingURL=index.js.map